import { Pipe, PipeTransform } from '@angular/core';
import { InstallationRoadSurfacePluginService } from './road-surface.service';
@Pipe({
    name: 'surfacetype',
    standalone: false
})
export class SurfaceTypePipe implements PipeTransform {
  public surfaceTypes: any[];
  constructor(private service: InstallationRoadSurfacePluginService) {
    this.surfaceTypes = this.service.getSurfaceTypes();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.surfaceTypes);
  }
}
